import { render, staticRenderFns } from "./ImagePaidOption.vue?vue&type=template&id=6bcb5790&"
import script from "./ImagePaidOption.vue?vue&type=script&lang=js&"
export * from "./ImagePaidOption.vue?vue&type=script&lang=js&"
import style0 from "./ImagePaidOption.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports